import {Action, createReducer, on} from '@ngrx/store';
import * as NavActions from './navigation.action';

export interface NavState {
  url: string;
  touchpoint: string;
  leftMenu : string;
  tabitem : string;
}

export const initialState: NavState = {
  url:"",
  touchpoint: "",
  leftMenu : "",
  tabitem : ""
};



export const navReducer = createReducer(
  initialState,
  on(NavActions.touchpoint, (state, {item}) => ({
    ...state,
    touchpoint: item
  })),
  on(NavActions.leftMenu, (state, {item}) => ({
    ...state,
    leftMenu: item
  })),
  on(NavActions.tabitem, (state, {item}) => ({
    ...state,
    tabitem: item
  })),
  on(NavActions.url, (state, {item}) => ({
    ...state,
    url: item
  })),
);
